module.exports = __webpack_public_path__ + "img/daily_2.2d13b975.png";